const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

function plural(n: number, unit: string): string {
  return `${n} ${unit}`;
}

/** Date relative en français (« il y a 5 min », « dans 2 h »). `now` est injectable pour les tests. */
export function relativeTime(iso: string | null | undefined, now: number = Date.now()): string {
  if (!iso) return 'jamais';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return 'date inconnue';
  const diff = now - t;
  const abs = Math.abs(diff);
  if (abs < 45_000) return "à l'instant";
  let label: string;
  if (abs < HOUR) label = plural(Math.max(1, Math.round(abs / MINUTE)), 'min');
  else if (abs < DAY) label = plural(Math.round(abs / HOUR), 'h');
  else if (abs < 30 * DAY) label = plural(Math.round(abs / DAY), 'j');
  else return new Date(t).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });
  return diff >= 0 ? `il y a ${label}` : `dans ${label}`;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return new Date(t).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'medium' });
}

/** Un rapport (ou tout horodatage) est périmé quand il a plus de `maxMs` ; une date absente ou illisible l'est aussi. */
export function isStale(
  iso: string | null | undefined,
  now: number = Date.now(),
  maxMs = 15 * MINUTE,
): boolean {
  if (!iso) return true;
  const t = Date.parse(iso);
  return Number.isNaN(t) || now - t > maxMs;
}

/** Taille en octets lisible (« 1,4 Mo »). */
export function formatBytes(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  if (n < 1024) return `${n} o`;
  if (n < 1024 * 1024) return `${(n / 1024).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} Ko`;
  return `${(n / (1024 * 1024)).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} Mo`;
}
